<template>
    <a-modal title="短信发送记录"
             :width="1200"
             :visible="visible"
             :maskClosable="false"
             destroyOnClose
             :footer="null"
             @cancel="$emit('cancel')"
    >
      <s-table
          ref="table"
          :columns="columns"
          :data="loadData"
          :rowKey="record => record.id"
          :pagination="{ showTotal: () => `共 ${total} 条` }"
      >
      </s-table>
    </a-modal>
</template>

<script>
import { STable } from '@/components'
import qs from 'qs'
export default {
  name: 'SmsTableModal',
  components: {
    STable
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
  },
  created () {
  },
  data () {
    return {
      itemLoading: false,
      columns: [
        {
          title: '手机号码',
          align: 'center',
          dataIndex: 'phone'
        },
        {
          title: '发送内容',
          align: 'center',
          dataIndex: 'content'
        },
        {
          title: '返回结果',
          align: 'center',
          dataIndex: 'result'
        },
        {
          title: '发送时间',
          align: 'center',
          dataIndex: 'createTime'
        }
      ],
      total: null,
      loadData: (parameter) => {
        const data = {}
        return this.$http.get('/api/v2/sms/query_sns_log_list.json', {
          params: Object.assign(parameter, data)
        }).then(res => {
          if (res.page) {
            this.total = res.page.total
          }
          return res
        })
      }
    }
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>

</style>
